/**
 * Web Timer Adapter - Browser timer implementation
 * @module @one-payments/adapters-web
 */

import type { TimerAdapter } from '@one-payments/core';

/**
 * Web Timer Adapter using native browser APIs
 */
export class WebTimerAdapter implements TimerAdapter {
  public now(): number {
    return Date.now();
  }

  public async delay(ms: number): Promise<void> {
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  }
}
